<template>
  <div class="terminos-page">
    <div class="terminos-img-placeholder">
      <img
        src="https://atriainnovation.com/uploads/2023/11/portada-industria-4.jpg"
        alt="Header"
        class="terminos-img"
      />
    </div>
    <div class="terminos-title-card">
      <h1>{{ content.title }}</h1>
    </div>
    <div class="terminos-main">
      <div class="terminos-intro">
        {{ content.intro }}
      </div>
      <div v-for="(section, idx) in content.sections" :key="idx" class="terminos-section">
        <div class="terminos-section-heading">{{ section.heading }}</div>
        <pre class="terminos-section-text">{{ section.text }}</pre>
      </div>
    </div>
    <SiteFooter :selectedLang="selectedLang" />
  </div>
</template>

<script>
import { useSEO } from '@/composables/useSEO';
import { terminosContent } from '@/assets/data/data.ts';
import SiteFooter from '@/components/SiteFooter.vue';

export default {
  name: 'TerminosYCondiciones',
  components: { SiteFooter },
  props: {
    selectedLang: {
      type: String,
      default: 'es'
    }
  },
  setup() {
    useSEO({
      title: 'Términos y Condiciones',
      description: 'Términos y condiciones de uso del sitio web y servicios de Frenkel Engineering. Información legal sobre el uso de nuestros servicios.',
      path: '/terminos-condiciones',
    });
  },
  computed: {
    content() {
      return terminosContent[this.selectedLang] || terminosContent.es;
    }
  }
};
</script>

<style scoped>
.terminos-page {
  min-height: 100vh;
  background: #f6fafb;
  font-family: 'IBM Plex Mono', monospace;
  display: flex;
  flex-direction: column;
}
.terminos-img-placeholder {
  width: 100%;
  height: 200px;
  background: #fff;
  border: 3px solid #222;
  margin-top: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.terminos-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}
.terminos-title-card {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 6px 16px 2px #9992;
  margin: -40px auto 0 auto;
  width: 72vw;
  min-width: 320px;
  max-width: 700px;
  padding: 0.8rem 0.2rem 0.6rem 0.2rem;
  text-align: justify;
  z-index: 3;
  position: relative;
}
.terminos-title-card h1 {
  font-family: 'Caveat-Bold', cursive;
  font-size: 2.4rem;
  font-weight: bold;
  margin: 0;
}
.terminos-main {
  width: 98vw;
  max-width: 820px;
  margin: 1.5rem auto 0 auto;
  background: none;
  font-family: 'IBM Plex Mono', monospace;
  font-size: 1rem;
}
.terminos-intro {
  margin-bottom: 16px;
  margin-top: 12px;
  white-space: pre-line;
}
.terminos-section {
  margin-bottom: 1.5rem;
}
.terminos-section-heading {
  font-weight: bold;
  margin-bottom: 0.1rem;
}
.terminos-section-text {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 1rem;
  white-space: pre-line;
  background: none;
  border: none;
  margin: 0 0 0.7rem 0;
  padding: 0;
  color: #222;
}
@media (max-width: 700px) {
  .terminos-title-card {
    width: 96vw;
    padding: 0.7rem 0.1rem 0.4rem 0.1rem;
    min-width: unset;
  }
  .terminos-main {
    width: 98vw;
    padding: 0 2vw;
    font-size: 0.96rem;
  }
  .terminos-img-placeholder {
    height: 120px;
  }
}
</style>
